import React from "react";

const SectionRule = ({className = ""}) => (
    <div aria-hidden="true" className={`relative w-full max-w-screen-2xl mx-auto px-5 ${className}`}>
        <hr className="cl-rule"/>
        <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 block w-1.5 h-1.5 bg-[var(--cl-accent)]"/>
    </div>
);

export default SectionRule;
